import { useEffect } from 'react';

import { DocumentNode, useMutation } from '@apollo/client';

import { logError } from '@/helpers/logger/logUtils';

const useHandledMutation = (mutation: DocumentNode) => {
  const [mutationHandler, { error }] = useMutation(mutation);

  useEffect(() => {
    if (error) {
      error.graphQLErrors.forEach((gqlError) => logError(gqlError));
    }
  }, [error]);

  return [mutationHandler] as const;
};

export default useHandledMutation;
